/**
 * @file PaddleHub 首页
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';
import { Col, Button, Row } from 'antd';

import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';
import Banner from './components/banner/Banner';
import LearnModelCards from './components/learn-model-cards/LearnModelCards';
import TeachingCards from './components/teaching-cards/TeachingCards';
import SupportCommunication from './components/support-communication/SupportCommunication';
import ApplicationScenarios from './components/application-scenarios/ApplicationScenarios';
import usePaddleHubIndexStore from './paddleHubHooks';
import UploadModelModal from './components/upload-model-modal/UploadModelModal';
import BannerCodeContainer from './components/banner-code-container/BannerCodeContainer';
import BannerTextCardGroup from './components/banner-text-card/BannerTextCardGroup';
import A from '../../components/a/A';


const PaddleHub: React.FC = () => {
    const {
        hubData,

        selectedTabKey,
        setSelectedTabKey,

        uploadModelHooks
    } = usePaddleHubIndexStore();

    const {
        banner,
        bannerTextCard,
        applicationScenarios,
        learnModel,
        teaching,
        support,
        hubStar
    } = hubData;

    return (
        <div className="page paddle-hub-index-page">
            <Header />

            <div className="paddle-hub-index-page-content">
                <Row gutter={50}>
                    <Col span={12}>
                        <Banner
                            title={banner.title}
                            subtitle={banner.desc}
                            divider
                        >
                            <ul className="paddle-hub-index-page-banner-tags clear-both">
                                {banner.tags.map((tag) => (
                                    <li key={tag}>{tag}</li>
                                ))}
                            </ul>
                            <div className="paddle-hub-index-page-banner-btn-group">
                                {banner.btns.map((btn) => (
                                    btn.type !== 'tag'
                                        ? <A
                                            key={`${btn.label}${btn.href}`}
                                            href={btn.href}
                                        >
                                            <Button
                                                type="primary"
                                                size="large"
                                                className="paddle-hub-index-page-banner-btn"
                                            >
                                                {btn.label}
                                            </Button>
                                        </A>
                                        : <A
                                            key={`${btn.label}${btn.href}`}
                                            className="paddle-hub-index-page-banner-tag"
                                            href={btn.href}
                                        >
                                            {hubStar}
                                        </A>
                                ))}
                            </div>
                        </Banner>
                    </Col>
                    <Col span={12}>
                        {!!banner.code
                            && (
                                <BannerCodeContainer code={banner.code} />
                            )}
                    </Col>
                </Row>
                <div>
                    <BannerTextCardGroup list={bannerTextCard} />
                </div>
                <div className="paddle-divider" />
            </div>
            <div className="paddle-hub-index-page-content">
                <div className="paddle-hub-index-page-context-h2">
                    {applicationScenarios.title}
                </div>
                <div className="paddle-hub-index-page-context-h3">
                    {applicationScenarios.subtitle}
                </div>
                <ApplicationScenarios
                    {...applicationScenarios}
                    selectedTabKey={selectedTabKey}
                    setSelectedTabKey={setSelectedTabKey}
                />

                <div className="paddle-hub-index-page-context-h2">
                    {learnModel.title}
                </div>
                <div className="paddle-hub-index-page-context-h3">
                    {learnModel.subtitle}
                </div>
                <LearnModelCards {...learnModel} />

                <div className="paddle-hub-index-page-context-h2">
                    {teaching.title}
                </div>
                <div className="paddle-hub-index-page-context-h3">
                    {teaching.subtitle}
                </div>
                <TeachingCards {...teaching} />

                <div className="paddle-hub-index-page-context-h2">
                    {support.title}
                </div>
                <div className="paddle-hub-index-page-context-h3">
                    {support.subtitle}
                </div>
                <SupportCommunication
                />
            </div>


            <UploadModelModal
                {...uploadModelHooks}
            />

            <Footer />
        </div>
    );
};

export default PaddleHub;
